<ng-container *ngIf="isMobile; else desktopModal">
  <app-swipe-up
    [height]="90"
    [showSwipeUp]="showForm"
    [showHeader]="true"
    [title]="'BOOKING_MODULE.PAX.NEW_PAX' | transloco: { traveler: travelerLabel | transloco }"
    [subTitle]="'BOOKING_MODULE.PAX.TYPE_PAX_DESCRIPTION' | transloco"
    (toggleShowSwipeUp)="closeForm.emit()">
    <ng-container content>
      <ng-container *ngTemplateOutlet="paxFormTemplate"></ng-container>
    </ng-container>
  </app-swipe-up>
</ng-container>

<ng-template #desktopModal>
  <ng-container *ngIf="showForm">
    <app-modal
      [width]="640"
      [showHeader]="true"
      (toggleModal)="closeForm.emit()"
      [title]="'BOOKING_MODULE.PAX.NEW_PAX' | transloco: { traveler: travelerLabel | transloco }"
      [subTitle]="'BOOKING_MODULE.PAX.TYPE_PAX_DESCRIPTION' | transloco">
      <ng-container content>
        <ng-container *ngTemplateOutlet="paxFormTemplate"></ng-container>
      </ng-container>
    </app-modal>
  </ng-container>
</ng-template>

<ng-template #paxFormTemplate>
  <ng-container formGroup]="form">
    <app-form-passenger
      [isMobile]="isMobile"
      [form]="form"
      [paxForm]="paxForm"
      [user]="user"
      [travelerAge]="travelerAge"
      [defaultFormData]="defaultFormData$ | async"
      [documents]="documents$ | async"
      [paxTraveler]="paxTraveler"
      [isAnInternationalTrip]="isAnInternationalTrip"
      [isCreateTraveler]="isCreateTraveler$ | async"
      [showFrequentFlyer]="showFrequentFlyer"
      [travelerNumber]="travelerNumber"
      [travelerInfoType]="travelerInfoType"
      [validator]="validator"
      [frequentFlyerPrograms]="frequentFlyerPrograms"
      [countries]="countries"
      [travelerBookingProvider]="travelerBookingProvider"
      [isSubmitted]="isSubmitted"
      [type]="travelerType"
      [businessRules]="businessRules"
      [productCode]="productCode"
      [productProvider]="productProvider"
      [isLoadingPaxForm]="isLoadingPaxForm"
      [disabledDocumentInputs]="disabledDocumentInputs"
      [documentType]="documentType$ | async"
      (setCreatePaxUI)="setCreatePaxUI($event)"
      (closeForm)="closeForm.emit()"
      (create)="submitForm($event, null)"
      (update)="submitForm(null, $event)">
    </app-form-passenger>
  </ng-container>
</ng-template>